// extracted by mini-css-extract-plugin
module.exports = {"restrictionModal":"RestictionModal_restrictionModal__1aKFb","modalClose":"RestictionModal_modalClose__3w0Ob"};